import { TaskType } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { CallIntelligenceWritebackV1 } from '@frontend/api-call-intel';
import { i18next } from '@frontend/i18n';
import { CallIntelSettingsTrackingIds } from './tracking-ids';

export const SyncOptionsList: {
  label: string;
  description: string;
  value: CallIntelligenceWritebackV1.Types.WritebackSettingMode;
  trackingId: string;
}[] = [
  {
    label: i18next.t('Off', { ns: 'settings>>call-intel-settings' }),
    description: i18next.t('Prevents call summaries from being uploaded to your PMS or EHR.', {
      ns: 'settings>>call-intel-settings',
    }),
    value: CallIntelligenceWritebackV1.Types.WritebackSettingMode.WRITEBACK_SETTING_MODE_OFF,
    trackingId: CallIntelSettingsTrackingIds.pmsSync.syncOptionOff,
  },
  {
    label: i18next.t('Manual', { ns: 'settings>>call-intel-settings' }),
    description: i18next.t('Use the Sync button to manually upload the call summary to your PMS or EHR.', {
      ns: 'settings>>call-intel-settings',
    }),
    value: CallIntelligenceWritebackV1.Types.WritebackSettingMode.WRITEBACK_SETTING_MODE_MANUAL,
    trackingId: CallIntelSettingsTrackingIds.pmsSync.syncOptionManual,
  },
  {
    label: i18next.t('Automatic', { ns: 'settings>>call-intel-settings' }),
    description: i18next.t('Every call summary is  automatically uploaded to your PMS or EHR after each call.', {
      ns: 'settings>>call-intel-settings',
    }),
    value: CallIntelligenceWritebackV1.Types.WritebackSettingMode.WRITEBACK_SETTING_MODE_AUTOMATIC,
    trackingId: CallIntelSettingsTrackingIds.pmsSync.syncOptionAutomatic,
  },
];

// TODO: Update link when documentation is ready
export const CALL_INTEL_SYNC_HELP_LINK = '#';
export const CALL_SUMMARY_PMS_SYNC_PERMISSION = Permission.CALL_INTELLIGENCE_WRITEBACK_MANAGE;
export const CALL_SUMMARY_SYNC_SETTING_NAME =
  CallIntelligenceWritebackV1.Types.WritebackSettingName.WRITEBACK_SETTING_CALL_SUMMARY;
export const TASK_SETTINGS_PERMISSION = Permission.CALL_INTELLIGENCE_MANAGE_AI_TASK_SETTINGS;

export const TASK_TYPE_LIST = [
  TaskType.TYPE_SCHEDULING,
  TaskType.TYPE_WAITLIST,
  TaskType.TYPE_PATIENT_CARE,
  TaskType.TYPE_BILLING,
  TaskType.TYPE_INSURANCE,
  TaskType.TYPE_OTHER,
] as const;
